import http from "../http-common";
const getReportsByDateAndType = (date, type) => {
  const params = {};
  if (date) {
    params.date = date;
  }
  if (type) {
    params.type = type;
  }
  return http.get('/reports/search', {
    params
  });
};

const getReportsByRouteIdAndType = (route_id, type) => {
  const params = {};
  if (route_id) {
    params.route_id = route_id;
  }
  if (type) {
    params.type = type;
  }
  return http.get('/reports/search-route', {
    params
  }); 
}

const createReport = (data) => {
	return http.post('/reports', data);
};

const updateReport = (id, data) => {
  return http.put(`/reports/${id}`, data);
}

const exportRouteReportZip = (date) => {
  return http.get('/reports/export-route-report', {
    params: { date },
    responseType: 'blob'
  });
};

const exportDietaryRecordsExcel = (date) => {
  return http.get('/reports/export-dietary-records', {
    params: { date },
    responseType: 'blob'
  });
};

const exportMealDailyRecordsExcel = (date) => {
  return http.get('/reports/export-meal-daily-records', {
    params: { date },
    responseType: 'blob'
  });
};

const exportSeatingChartDietaryExcel = (date) => {
  return http.get('/reports/export-seating-chart-dietary', {
    params: { date },
    responseType: 'blob'
  });
};

const exportDriverDailyTimesheetExcel = (date) => {
  return http.get('/reports/export-driver-daily-timesheet', {
    params: { date },
    responseType: 'blob'
  });
};

const exportDriverWeeklyTimesheetExcel = (weekStart) => {
  return http.get('/reports/export-driver-weekly-timesheet', {
    params: { weekStart },
    responseType: 'blob'
  });
};

export const ReportService = {
  getReportsByDateAndType,
  createReport,
  updateReport,
  getReportsByRouteIdAndType,
  exportRouteReportZip,
  exportDietaryRecordsExcel,
  exportMealDailyRecordsExcel,
  exportSeatingChartDietaryExcel,
  exportDriverDailyTimesheetExcel,
  exportDriverWeeklyTimesheetExcel
};
